import React, { useState } from "react";
import emailjs from "@emailjs/browser";

import "./ContactForm.scss";
import { ReactComponent as SideBtnBlack } from "../../assets/svg/side-btn-black.svg";
import emailjsConfig from "../../config/emailjs";

const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    company: "",
    message: "",
    privacyPolicy: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    const templateParams = {
      name: `${formData.firstname} ${formData.lastname}`.trim(),
      firstname: formData.firstname,
      lastname: formData.lastname,
      email: formData.email,
      company: formData.company,
      message: formData.message,
    };

    try {
      await emailjs.send(
        emailjsConfig.serviceId,
        emailjsConfig.templateId,
        templateParams,
        {
          publicKey: emailjsConfig.publicKey,
        }
      );

      setSuccessMessage("Message sent successfully!");
      setFormData({
        firstname: "",
        lastname: "",
        email: "",
        company: "",
        message: "",
        privacyPolicy: false,
      });
    } catch (error) {
      console.error("Error sending email:", error);
      const details =
        error?.text || error?.message || "Failed to send message. Please try again.";
      setErrorMessage(details);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;

    setFormData({
      ...formData,
      [name]: val,
    });
  };

  return (
    <section className="section contactForm">
      <article className="contactForm__container container">
        <form className="contactForm__container--form" onSubmit={handleSubmit}>
          <div className="form__wrapper">
            <div className="form__group--pair">
              <div className="form__group">
                <label>First name:*</label>
                <input
                  type="text"
                  name="firstname"
                  placeholder="Your first name"
                  className="form__input"
                  value={formData.firstname}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form__group">
                <label>Last name:*</label>
                <input
                  type="text"
                  name="lastname"
                  placeholder="Your last name"
                  className="form__input"
                  value={formData.lastname}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form__group--pair">
              <div className="form__group">
                <label>Email:*</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Your email"
                  className="form__input"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form__group">
                <label>Company Name:*</label>
                <input
                  type="text"
                  name="company"
                  placeholder="Your company name"
                  className="form__input"
                  value={formData.company}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form__group-textarea">
              <label>
                Tell Us About The Project (Scope, Timeline, Budget):*
              </label>
              <textarea
                rows={5}
                cols={50}
                name="message"
                placeholder="Tell us about your project"
                className="form__input"
                value={formData.message}
                onChange={handleInputChange}
                required
              ></textarea>
            </div>
          </div>

          <div className="form__group--checkbox">
            <input
              className="radio-input"
              type="checkbox"
              name="privacyPolicy"
              id="privacy-policy"
              checked={formData.privacyPolicy}
              onChange={handleInputChange}
              required
            />
            <label className="radio-label" htmlFor="privacy-policy">
              <span className="radio-inner-circle"></span>Yes, sign me up!
            </label>
          </div>
          {errorMessage && (
            <p className="form__error-message">{errorMessage}</p>
          )}
          <button type="submit" className="form__group--submit">
            {loading ? (
              <div className="spinner"></div>
            ) : (
              <>
                {successMessage ? (
                  <span>{successMessage}</span>
                ) : (
                  <>
                    <div className="form__submit-btn">
                      <span>Send enquiry</span>
                    </div>
                    <SideBtnBlack />
                  </>
                )}
              </>
            )}
          </button>
        </form>
      </article>
    </section>
  );
};

export default ContactForm;
